export default __webpack_public_path__ + "static/media/bgadmin.e47946c6.svg";